// ButtonComponent
import React from 'react';
import './ButtonComponent.css';

const ButtonComponent = ({
    color = 'primary',
    hoverColor,
    icon,
    iconPosition = 'left',
    rounded = false,
    children,
    size = '',
    disabled = false,
    disabledColor = '#ccc',
    style = {},
    ...props
}) => {
    const buttonWidth = size === 'full' ? '100%' : size === 'half' ? '50%' : size === 'small' ? '25%' : '';
    return (
        <button
            className={`custom-button`}
            {...props}
            style={{
                // backgroundColor: disabled ? disabledColor : hoverColor || color,
                width: buttonWidth,
                cursor: disabled ? 'not-allowed' : 'pointer',
                opacity: disabled ? 0.3 : 1,
                ...style
            }}
            disabled={disabled}
        >
            {icon && iconPosition === 'left' && <img src={icon} className='custom-button-left-icon' />}
            {children}
            {icon && iconPosition === 'right' && <img src={icon} className='custom-button-right-icon' />}
        </button>
    );
};

export default ButtonComponent;
